import { forwardRef, Icon, IconProps } from '@chakra-ui/react';

const HidePassword = forwardRef<IconProps, 'svg'>((props, ref) => (
  <Icon ref={ref} viewBox="0 0 16 16" {...props}>
    <path
      clipRule="evenodd"
      d="M12.862 13.805 2.195 3.138l.943-.943L4.72 3.778a4.653 4.653 0 0 1 1.994-.445l2.575.001a4.63 4.63 0 0 1 3.297 1.367l2.357 2.357c.52.519.52 1.366 0 1.885-.84.84-1.65 1.73-2.533 2.524l1.395 1.395-.943.943Zm-1.397-3.282-1.66-1.661a2 2 0 0 0-2.667-2.667L5.75 4.807c.309-.092.633-.14.964-.14h2.574c.89 0 1.726.346 2.356.977L14 8c-.837.837-1.638 1.75-2.536 2.523Z"
      fill="currentColor"
      fillRule="evenodd"
    />
    <path
      d="M2.642 5.472 1.057 7.057c-.52.52-.52 1.367 0 1.886L3.413 11.3a4.636 4.636 0 0 0 3.3 1.367h2.574c.174 0 .347-.01.519-.03l-1.304-1.304h-1.79c-.89 0-1.726-.346-2.357-.976L2 8l1.586-1.586-.943-.942Z"
      fill="currentColor"
    />
  </Icon>
));

export default HidePassword;
